import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-whatsapp-button',
  templateUrl: './whatsapp-button.component.html',
  styleUrls: ['./whatsapp-button.component.css']
})
export class WhatsappButtonComponent implements OnInit {
  @Input() whatsappNumber;

  constructor() { }

  ngOnInit() {
  }

}
